export default class ELExercise {
  static from(json){
    return Object.assign(new ELExercise(), json);
  }
  firstLetter() {
    return this.name.charAt(0);
  }
}